import messages from '@proj-airi/i18n/locales'

import { resolveInitialLocale } from '@proj-airi/i18n'
import { createI18n } from 'vue-i18n'

function getLocale() {
  return resolveInitialLocale(Object.keys(messages!))
}

export const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  fallbackLocale: 'en',
  messages,
  warnHtmlMessage: false,
})
